import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MessagingPlatform } from '@this+that/models';
import log from 'loglevel';

import { deleteLabel } from '../../services/labels.service';
import { deleteFolder } from '../../services/outlookFolders.service';
import { useIntegrationsStore, useLabelsStore } from '../../store';
import { getHomeAccountId } from '../../utils/integrationAccountHelpers';
import { useCustomToast } from '../useCustomToast';

export const useDeleteLabel = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const { successMessage, errorMessage } = useCustomToast();

  const { deleteLabel: deleteLabelState } = useLabelsStore();
  const { integrationAccounts } = useIntegrationsStore();

  const handleDeleteLabel = async (
    id: string,
    emailAddress: string,
    platform: MessagingPlatform,
  ) => {
    setIsLoading(true);
    try {
      if (platform === MessagingPlatform.GMAIL) {
        await deleteLabel({ labelId: id, emailAddress });
      } else if (platform === MessagingPlatform.OUTLOOK) {
        const platformAccountId = getHomeAccountId(
          emailAddress,
          integrationAccounts,
        );
        await deleteFolder({
          labelId: id,
          platformAccountId,
        });
      }
      deleteLabelState(id);
      successMessage(t('inbox.labels.deleteLabelSuccess'));
    } catch (error) {
      log.error('Error deleting label/folder:', error);
      errorMessage(t('inbox.labels.deleteLabelError'));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleDeleteLabel,
    isLoading,
  };
};
